/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Empirical_Linguistics25Inputs */

const en__field_enum_study_empirical_linguistics25 = /** @type {(inputs: _Field_Enum_Study_Empirical_Linguistics25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirical Linguistics`)
};

const de__field_enum_study_empirical_linguistics25 = /** @type {(inputs: _Field_Enum_Study_Empirical_Linguistics25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirische Sprachwissenschaften`)
};

/**
* | output |
* | --- |
* | "Empirical Linguistics" |
*
* @param {_Field_Enum_Study_Empirical_Linguistics25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_empirical_linguistics25 = /** @type {((inputs?: _Field_Enum_Study_Empirical_Linguistics25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Empirical_Linguistics25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_empirical_linguistics25(inputs)
	return de__field_enum_study_empirical_linguistics25(inputs)
});
export { _field_enum_study_empirical_linguistics25 as "_field_enum_STUDY_EMPIRICAL_LINGUISTICS" }